<script>
import { Doughnut, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    pieChartType: String,
    isHalf: Boolean,
    legendFontSize: Number,
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          titleFontSize: 14,
          titleMarginBottom: 8,
          bodyFontSize: 15,
          bodySpacing: 10,
          callbacks: {
            label: (tooltipItems, data) => {
              const index = tooltipItems.index;
              return `${this.chartData.labels[index]} ${_.getMoneyFormat(
                this.chartData.datasets[0].data[index]
              )}`;
            },
          },
          legendTemplate: "<h1>Hii</h1>",
        },
        rotation: this.isHalf ? 1 * Math.PI : 0,
        circumference: this.isHalf ? 1 * Math.PI : 2 * Math.PI,
        legend: {
          display: false,
          position: "right",
          align: "center",
          fullWidth: true,
          labels: {
            fontSize: this.legendFontSize ?? 16,
            display: false,
          },
        },
        onClick: this.handle,
        showAllTooltips: false,
      };
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    handle(point, event) {
      const item = event[0];
    },
  },
};
</script>